import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createUserSettingsSchemas } from 'shared/db/validation/schemas/userSettings';
import { Validator } from 'shared/db/validation/validator';
import { DeleteRawRecord, UpdateRawRecord } from 'shared/types/rawRecordFields';
import { UserSettingsRawRecord } from 'shared/types/UserSettings';
import { UserSettingsDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createUserSettingsSchemas();

const addValidator = createDBEntityValidator<UserSettingsRawRecord>(
    schemas.add,
);
const updateValidator = createDBEntityValidator<
    UpdateRawRecord<UserSettingsRawRecord>
>(schemas.update);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-user-settings'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createUserSettingsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const userSettingsInputValidation: UserSettingsDBValidation = {
    add: createUserSettingsInputValidation(addValidator, validationStrategy),
    update: createUserSettingsInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createUserSettingsInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
